import BaseControl from "./BaseControl"
import CDropdown from "./CDropdown"
import Label from "./Label"

const DropdownControl = ({
    text="Text",
    caption="",
    selected=0,
    items=["Item 1", "Item 2", "Item 3"],
    colors=[""],
    edit=true,
    onSelected=(key:string|null,index:number)=>{}}) => {
    return <BaseControl text={text} caption={caption}>
        <>
        {edit && <div>
            <CDropdown selected={selected} 
                items={items}
                colors={colors}
                onSelected={onSelected}/>
        </div>}
        { !edit && <Label fontWeight="400" textAlign='end' padding="">{items[selected]}</Label>}
        </>
    </BaseControl>
}

export default DropdownControl